import * as React from 'react';
import LoginButton from '../AuthContext/LoginButton';
import PixelsPanel from '../molecules/PixelsPanel';

interface IProps {
  loading?: boolean;
}

const LoginLayout: React.FC<IProps> = ({ loading }) => {
  return (
    <div className="login-layout">
      <PixelsPanel />
      <div className="login-layout__content">
        <h1>Pluto</h1>
        <LoginButton loading={loading} />
      </div>
      <PixelsPanel />
    </div>
  );
};

export default LoginLayout;
